import * as React from 'react';
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {FormattedMessage, injectIntl} from "react-intl";
import _ from "lodash";
import classnames from "classnames";
import ImageOpenAnswer from "../imageOpenAnswer";
import QuestionContainer from "../questionContainer";
import MatrixRequiredAnswersInfo from "./matrixRequiredAnswersInfo";
import AnswerContainer from "../answerContainer";
import {cloneElement, useEffect} from "react";
import {setSurveyNavShowNextButton} from "../../../../../reducers/surveyNav/actions";
import Select from "react-select";
import api from "api";
import { useSwipeable } from 'react-swipeable';
import {setValidate} from "../../../../../reducers/page/actions";

function MobileMatrix(props) {
	const {question, contentRow, contentColumn, intl, validated, details, page, onChangeContentRow, onChangeContentColumn, onItemClick, survey, isColumnError, setSurveyNavShowNextButton, getAnswerLabel, onSelect, validate, validationTexts, setValidate, questionResponse} = props
	const transposed = question.presentationType === 'carousel' ? false : question.transposed;
	const [currentRow, setCurrentRow] = React.useState(0)
	const [rowValidation, setRowValidation] = React.useState(false)
	const [showNextStatement, setShowNextStatement] = React.useState(true)
	const [showPrevStatement, setShowPrevStatement] = React.useState(false)

	const showInitialSwipe = () => {
		if (question.presentationType === 'carousel') {
			if (window.innerWidth < 992) {
				return true;
			}
		}

		return false;
	}

	const [showSwipeLeft, setShowSwipeLeft] = React.useState(showInitialSwipe())
	const [showSwipeRight, serShowSwipeRight] = React.useState(showInitialSwipe())

	const rows = transposed ? question.columns : question.rows;
	const columns = transposed ? question.rows : question.columns;
	const rowsImage = transposed ? question.columnsImage : question.rowsImage;
	const columnsImage = transposed ? question.rowsImage : question.columnsImage;
	const answersOptions = question.answers ? _.map(question.answers, answer => {
		return {label: getAnswerLabel(answer), value: answer.id}
	}) : null;

	const getRequiredMinRows = () => {
		if (question.requiredAllDropdowns) {
			return columns.length;
		}

		if (transposed) {
			if (question.columnsMin) {
				return question.columnsMin;
			}
		} else {
			if (question.rowsMin) {
				return question.rowsMin;
			}
		}

		if (transposed) {
			if (question.requiredColumns) {
				return 1;
			}
		} else {
			if (question.requiredRows) {
				return 1;
			}
		}

		return 0;
	}

	const pushError = (valObject) => {
		const pageValidation = page ? page : [];
		pageValidation[question.id] = valObject;

		setValidate(pageValidation);
	}

	const canGo = (doValidation) => {
		const row = rows[currentRow]
		const requiredRows = getRequiredMinRows();
		const valObject = {valid: false, errors: []}
		let toReturn = true;

		const filteredDetails = details.filter(detail => {
			if (transposed) {
				return detail.column === row.id
			} else {
				return detail.row === row.id
			}
		});
		const detail = filteredDetails.length > 0 ? filteredDetails[0] : ""
		const rowContent = row ? (transposed ? contentColumn[row.id] : contentRow[row.id]) : "";

		if (row.excludeRequired) {
			toReturn = true;
		} else if (row && row.isOpen && row.openIsRequired && !rowContent) {
			toReturn = false;
			if (doValidation) {
				if (question.validationTextMobile) {
					valObject.errors.push(question.validationTextMobile);
				} else {
					valObject.errors.push(validationTexts.detail.rowContentEmpty ? validationTexts.detail.rowContentEmpty : "Complete the open answer in the line");
				}
			}
		} else if (requiredRows && filteredDetails.length < requiredRows) {
			if (doValidation) {
				if (question.requiredAllDropdowns) {
					valObject.errors.push(question.validationTextMobile ? question.validationTextMobile : validationTexts.requiredAllDropdowns);
				} else if (question.rowsMin) {
					valObject.errors.push(question.validationTextMobile ? question.validationTextMobile : validationTexts.rowsMin);
				} else if (question.requiredRows) {
					valObject.errors.push(question.validationTextMobile ? question.validationTextMobile : validationTexts.requiredRows);
				}
			}
			toReturn = false;
		} else if (row.blocking && filteredDetails.length === 0) {
			toReturn = false;
			if (doValidation) {
				valObject.errors.push(question.validationTextMobile ? question.validationTextMobile : validationTexts.requiredRows);
			}
		}



		details.forEach((entry) => {
			const columnToCheck = columns.find((column) => {
				return column.id === entry.column && !entry.contentColumn;
			})

			if (columnToCheck && columnToCheck.isOpen && columnToCheck.openIsRequired && !valObject.errors.includes(validationTexts.detail.rowColumnEmpty ? validationTexts.detail.rowColumnEmpty : "Complete the open answer in the column")) {
				toReturn = false;
				if (doValidation) {
					if (question.validationTextMobile) {
						valObject.errors.push(question.validationTextMobile);
					} else {
						valObject.errors.push(validationTexts.detail.rowContentEmpty ? validationTexts.detail.rowContentEmpty : "Complete the open answer in the line");
					}
				}
			}
		})

		if (doValidation && valObject.errors.length > 0) {
			pushError(valObject);
			setRowValidation(true)
		}

		if (doValidation && valObject.errors.length === 0) {
			pushError(null)
			setRowValidation(false)
		}

		return toReturn;
	}

	const rowChecked = canGo()

	useEffect(() => {
		setTimeout(() => {
			setShowSwipeLeft(false)
			serShowSwipeRight(false)
		}, 2000)
		setSurveyNavShowNextButton(false)
	}, [])

	useEffect(() => {
		canGo(rowValidation);
	}, [question, contentRow, contentColumn, details])

	const config = {
		delta: 10,                             // min distance(px) before a swipe starts. *See Notes*
		preventScrollOnSwipe: false,           // prevents scroll during swipe (*See Details*)
		trackTouch: true,                      // track touch input
		trackMouse: true,                     // track mouse input
		rotationAngle: 0,                      // set a rotation angle
		swipeDuration: Infinity,               // allowable duration of a swipe (ms). *See Notes*
		touchEventOptions: {passive: true}
	}

	const nextStatement = (swipe) => {
		if (currentRow === (rows.length - 1)) {
			return;
		}

		const result = canGo(true)
		if (swipe) {
			setShowSwipeLeft(true);
			setTimeout(() => {
				setShowSwipeLeft(false);
			}, 2000)
		}

		if (result) {
			if (currentRow === (rows.length - 2)) {
				setSurveyNavShowNextButton(true);
			}
			var root = document.getElementById('question-' + question.id);
			root.scrollIntoView({behavior:"instant", block: "start", inline:"nearest"});
			setCurrentRow(currentRow+1)
			setShowNextStatement(true);
			setShowPrevStatement(false);
		}
	}

	const prevStatement = () => {
		var root = document.getElementById('question-' + question.id);
		root.scrollIntoView({behavior:"instant", block: "start", inline:"nearest"});
		setSurveyNavShowNextButton(false);
		setCurrentRow(currentRow-1)
		setShowNextStatement(false);
		setShowPrevStatement(true);
	}

	const handlers = useSwipeable({
		onSwipedLeft: (() => nextStatement(true)),
		onSwipedRight: (eventData => {
			if (currentRow > 0) {
				serShowSwipeRight(true);
				setTimeout(() => {
					serShowSwipeRight(false);
				}, 2000)
				prevStatement(true);
			}
		}),
		...config,
	});

	const getImageOpenAnswer = (column, row, checked) => {
		let imageOpenAnswerProps = null;

		if (question.type === 'matrixDropdown' && column.isOpen) {
			imageOpenAnswerProps = {
				checkboxType: "",
				showInput: true,
				showContent: false,
				onOpenChange: (e) => {
					if (transposed) {
						onChangeContentRow(column.id, e.target.value)
					} else {
						onChangeContentColumn(column.id, e.target.value)
					}}
			}
		}

		if (question.type === 'matrix') {
			imageOpenAnswerProps = {
				checkboxType: "radio",
				showInput: (column.isOpen && checked),
				showContent: (column.isOpen && checked) === false,
				onOpenChange: (e) => {
					if (transposed) {
						onChangeContentRow(column.id, e.target.value, row.id)
					} else {
						onChangeContentColumn(column.id, e.target.value, row.id)
					}}
			}
		}

		if (question.type === 'matrixMulti') {
			imageOpenAnswerProps = {
				checkboxType: "checkbox",
				showInput: (column.isOpen && checked),
				showContent: (column.isOpen && checked) === false,
				onOpenChange: (e) => {
					if (transposed) {
						onChangeContentRow(column.id, e.target.value, row.id)
					} else {
						onChangeContentColumn(column.id, e.target.value, row.id)
					}}
			}
		}

		return imageOpenAnswerProps
	}

	const isColumnDisabled = (column, row) => {
		const rowsMax = question.rowsMax;

		const columnBlocking = columns.find((columnBlock) => {
			return columnBlock.blocking && details.find((detail) => {
				if (transposed) {
					return detail.row === columnBlock.id && detail.column === column.id;
				} else {
					return detail.column === columnBlock.id && detail.row === row.id;
				}
			})
		})

		const rowBlocking = rows.find((rowBlock) => {
			return rowBlock.blocking && details.find((detail) => {
				if (transposed) {
					return detail.column === rowBlock.id;
				} else {
					return detail.row === rowBlock.id;
				}
			})
		})

		if (columnBlocking && column.id !== columnBlocking.id) {
			return true;
		}

		if (rowBlocking && row.id === rowBlocking.id) {
			return true;
		}

		if (rowsMax) {
			if (question.transposed) {
				const rowLengthTrans = details.filter((detail) => detail.row === column.id).length;
				if (rowsMax <= rowLengthTrans) {
					return true;
				}
			} else {
				const rowLength = details.filter((detail) => detail.row === row.id).length;
				if (rowsMax <= rowLength) {
					return true;
				}
			}
		}

		return false;
	}

	const getRowsContainerClasses = () => {
		const forceCafeteryStyles = question.forceCafeteryStyles;
		let forceClasses = "";
		if (forceCafeteryStyles.rows && forceCafeteryStyles.rows.textAlign) {
			forceClasses += 'forceAlignCenter ';
		}

		return forceClasses;
	}

	const getColumnsContainerClasses = () => {
		const forceCafeteryStyles = question.forceCafeteryStyles;
		let forceClasses = "";
		if (forceCafeteryStyles.columns && forceCafeteryStyles.columns.textAlign) {
			forceClasses += 'forceAlignCenter ';
		}

		return forceClasses;
	}

	const isError = ((validated || rowValidation) && !rowChecked) || ((validated || rowValidation) && isColumnError)

	return <React.Fragment>
		{_.map(rows, (row, index) => {
			const rowContent = transposed ? contentColumn[row.id] : contentRow[row.id];

			if (index !== currentRow) {
				return <React.Fragment />
			}
			return <div {...handlers} className={classnames({
				"matrix-card position-relative": true,
				"d-md-none": question.presentationType === 'table',
				"error": isError && !questionResponse.excluding
			})}>
				<React.Fragment>
					{showSwipeLeft && <div className={classnames({
						"position-absolute swipe swipe-left": true
					})}>
						<i className="fas fa-chevrons-right"/>
					</div>}
					{showSwipeRight && <div className={classnames({
						"position-absolute swipe swipe-right": true
					})}>
						<i className="fas fa-chevrons-left"/>
					</div>}
					<div className={classnames({
						"forceAlignCenter": getRowsContainerClasses()
					}) + " matrix-instruction"}>
						<ImageOpenAnswer
							answer={row}
							answersImage={rowsImage}
							showInput={false}
							showContent={true}
							answerOpenAlwaysShow={false}
						/>
						{row.isOpen && <div className={"mt-2"}>
							<ImageOpenAnswer
								answer={row}
								detail={rowContent}
								onlyInput={true}
								showInput={true}
								showContent={false}
								answerOpenAlwaysShow={false}
								onOpenChange={(e) => {
									if (transposed) {
										onChangeContentColumn(row.id, e.target.value)
									} else {
										onChangeContentRow(row.id, e.target.value)
									}
								}}
							/>
						</div>}
					</div>
					<QuestionContainer
						classes={classnames({
							'no-auto-rows': question.type === 'matrixDropdown'
						}) + " " + getColumnsContainerClasses()}
						gridLine={false}
						answersColumns={question.answersColumns ? question.answersColumns : 1}
						component={<React.Fragment>
							<MatrixRequiredAnswersInfo question={question} />
							{_.map(columns, (column, index) => {
								const columnContent = transposed ? contentRow[column.id] : contentColumn[column.id];
								const detail = details.find(detail => {
									if (transposed) {
										return detail.column === row.id && detail.row === column.id
									} else {
										return detail.row === row.id && detail.column === column.id
									}
								});
								const checked = !!detail
								const imageOpenAnswerProps = getImageOpenAnswer(column, row, checked)

								const disabledColumn = isColumnDisabled(column, row);

								return <React.Fragment>
									{question.answers && <div className={classnames({
										'dropdown-container p-1': true,
										'selected': checked,
									})}
									>
										<p className={'color-default font-weight-bold mt-3 mb-3'} dangerouslySetInnerHTML={{__html: column.content}}/>
										<Select
											maxMenuHeight={408}
											class={"dropdown-wrapper"}
											placeholder={intl.formatMessage({id: 'question.dropdown.open'})}
											isMulti={false}
											value={detail ? {value: detail.answer, label: getAnswerLabel(question.answers.find(answer => answer.id === detail.answer)) } : null}
											onChange={e => onSelect(row.id, column.id, e.value)}
											options={answersOptions}
											isSearchable={false}
											inputProps={{readOnly:true}}
											matchProp="label"
										/>
									</div>}
									{imageOpenAnswerProps && <AnswerContainer
										checked={checked}
										onClick={(e) => {
											if(e.target.tagName != 'INPUT') {
												onItemClick(row, column)
											}
										}}
										isNotActive={disabledColumn && !checked}
										answer={column}
										component={
											<React.Fragment>
												<ImageOpenAnswer
													{...imageOpenAnswerProps}
													answer={column}
													checked={checked}
													detail={question.presentationType === 'carousel' && detail ? detail.contentColumn : columnContent}
													answersImage={columnsImage}
													answerOpenAlwaysShow={false}
												/>
											</React.Fragment>
										}
									/>}
								</React.Fragment>
							})}
						</React.Fragment>}
					/>
				</React.Fragment>
			</div>
		})}
		<div className={classnames({
			"mt-4 position-relative matrix-button-container": true,
			"d-flex d-md-none": question.presentationType === 'table',
			"d-flex": question.presentationType === 'carousel',
		})}>
			<button className={classnames({
				"disabled": false,
				"active": false,
				'prev-statement': true,
				'show-text': (showPrevStatement && currentRow !== 0),
				'invisible': currentRow === 0,
				"rounded-button gray float-left pl-3 pr-3": true
			})}
				onClick={() => prevStatement()}>
				<i className="fas fa-chevron-left position-absolute"/>
				{(showPrevStatement && currentRow !== 0) && <React.Fragment>
					{survey.buttonQuestionPrevStatement ? survey.buttonQuestionPrevStatement : <FormattedMessage id="question.matrix.previousStatement" />}
				</React.Fragment>}
			</button>
			<button  className={classnames({
				"active": !isError,
				'show-text': (showNextStatement && currentRow < rows.length) || currentRow === 0,
				'next-statement': true,
				'invisible': currentRow === (rows.length - 1),
				'disabled-clickable': isError,
				"rounded-button gray text-center float-right flex-grow-1": true
			})} onClick={() => nextStatement()}>
				{(showNextStatement || currentRow === 0) && <React.Fragment>
					{survey.buttonQuestionNextStatement ? survey.buttonQuestionNextStatement : <FormattedMessage id="question.matrix.nextStatement" />}
				</React.Fragment>}
				<i className="pr-2 fas fa-chevron-right position-absolute"/>
			</button>
		</div>
	</React.Fragment>
}

MobileMatrix.propTypes = {
	question: PropTypes.any
};

function mapStateToProps(state) {
	return {
		page: state.page,
		survey: state.survey
	}
}

export default connect(mapStateToProps, {setSurveyNavShowNextButton, setValidate})(injectIntl(MobileMatrix));